import { InjectionToken } from '@angular/core';

export const INDEXED_DB_CONFIG = new InjectionToken<[string, number]>('IndexedDBConfig');
